<script>
import store from '@shared/store'
import i18n from '@shared/module/i18n'
import { setChatLanguage } from '@shared/module/chat'

export default {
  methods: {
    setLanguage(language) {
      i18n.locale = language
      store.setLocale(language)
      setChatLanguage(language)
    },
    getLanguage() {
      return i18n.locale
    }
  }
}
</script>
